import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';
import { ComponentDataTable, DatatableEmployeeName } from '../../../components';

const employeeColumns = [
  {
    name: 'NOMBRE',
    selector: 'fullName',
    cell: item => <DatatableEmployeeName item={item} fileName="fileInfo" name="fullName" fileUrl="fileUrl" />,
    grow: '3',
    sortable: true
  }
];

const CompanyTaskInfoShow = ({ task }) => {
  const renderAttribute = (label, value, md = 3) => (
    <Col md={md} className="mb-3">
      <div className="d-flex flex-column">
        <span className="type">{label}</span>
        <span className={`answer ${!value ? 'text-grey' : ''}`}>{value || 'No Aplica'}</span>
      </div>
    </Col>
  );

  return (
    <>
      <Card className="mb-4">
        <Col className="top-header-green">
          <div className="card-header-title">Datos Generales</div>
        </Col>
        <Card.Body>
          <Row>
            {renderAttribute('Título', task.title)}
            {renderAttribute('Desde', task.startDate)}
            {renderAttribute('Hasta', task.endDate)}
            {renderAttribute('Prioridad', task.translatedPriority)}
          </Row>
          <Row>
            {renderAttribute('Estado', task.translatedStatus)}
            {renderAttribute('Enviar Mail', task.sendEmail ? 'Si' : 'No')}
            {renderAttribute('Enviar Notificación', task.sendNotification ? 'Si' : 'No')}
          </Row>
          {task.description && <Row>{renderAttribute('Descripción', task.description, 12)}</Row>}
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Col className="top-header-green">
          <div className="card-header-title">Comentarios</div>
        </Col>
        <Card.Body>
          {task.companyTaskComments?.length > 0 ? (
            <div className="mb-4">
              {task.companyTaskComments.map((comment, index) => (
                <div key={comment.id} className="mb-3">
                  <p className="mb-1">
                    <span className="font-weight-bold">{comment.employeeName}:</span>
                    <span className="ml-1">{comment.comment}</span>
                  </p>
                  <p className="text-muted small mb-2">{comment.createdAt}</p>
                  {index !== task.companyTaskComments.length - 1 && <hr className="my-2 border-light" />}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-muted mb-4">No hay comentarios aún.</p>
          )}
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Col className="top-header-green">
          <div className="card-header-title">Colaborador Asignado</div>
        </Col>
        <Card.Body className="p-0">
          <div className="data-table-yellow">
            <ComponentDataTable
              columns={employeeColumns}
              data={task.employees || []}
              totalRows={task.employees?.length || 0}
              withDateSelect={false}
              withSearch={false}
              withPagination={false}
              onRequest={false}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default CompanyTaskInfoShow;
